import { TACO0 } from "./TACO0";
import spotlight from "url:../../assets/taco/spotlight.png";
import bongo_base from "url:../../assets/taco/dressup/bongodressup-base.png";
import ear_blue from "url:../../assets/taco/dressup/bongodressup_blueear.png";
import ear_pink from "url:../../assets/taco/dressup/bongodressup_pinkear.png";
import clothes_bowtie from "url:../../assets/taco/dressup/bongodressup_clothes-bowtie.png";
import clothes_nose from "url:../../assets/taco/dressup/bongodressup_clothes-nose.png";
import clothes_shoes from "url:../../assets/taco/dressup/bongodressup_clothes-shoes.png";
import clothes_tie from "url:../../assets/taco/dressup/bongodressup_clothes-tie.png";
import clothes_flower from "url:../../assets/taco/dressup/bongodressup_clothes-waterflower.png";
import makeup_black from "url:../../assets/taco/dressup/bongodressup_makeup-black.png";
import makeup_blush from "url:../../assets/taco/dressup/bongodressup_makeup-blush.png";
import makeup_brows from "url:../../assets/taco/dressup/bongodressup_makeup-eyebrows.png";
import makeup_moons from "url:../../assets/taco/dressup/bongodressup_makeup-eyemoons.png";
import makeup_lips from "url:../../assets/taco/dressup/bongodressup_makeup-lips.png";
import makeup_outline from "url:../../assets/taco/dressup/bongodressup_makeup-outline.png";
import makeup_spot1 from "url:../../assets/taco/dressup/bongodressup_makeup-spot1.png";
import makeup_spot2 from "url:../../assets/taco/dressup/bongodressup_makeup-spot2.png";
import makeup_spot3 from "url:../../assets/taco/dressup/bongodressup_makeup-spot3.png";
import makeup_spot4 from "url:../../assets/taco/dressup/bongodressup_makeup-spot4.png";
import makeup_spot5 from "url:../../assets/taco/dressup/bongodressup_makeup-spot5.png";
import makeup_tears from "url:../../assets/taco/dressup/bongodressup_makeup-tears.png";
import makeup_triangles from "url:../../assets/taco/dressup/bongodressup_makeup-triangles.png";
import wig from "url:../../assets/taco/dressup/bongodressup_wig.png";
import { useContext, useEffect, useRef, useState } from "react";
import { CursorComponent } from "../../components/cursor/CursorComponent";
import { CursorState } from "../../providers/CursorProvider";
import TACOProvider from "./TACOProvider";

export function TACOG () {
    return <DRESSUP onClick={() => {}} />
}

class DRESSUP_OPTION {
    id: number = 0;
    src: string = "";
    on: boolean = false;
    height: number = 100;
    x: number = 0;
    y: number = 0;

    constructor (id: number, src: string, height: number, x: number, y: number)
    {
        this.id = id;
        this.src = src;
        this.height = height;
        this.x = x;
        this.y = y;
    }

    load(data : number[]) {
        this.on = data.includes(this.id);
    }

    icon(onClick : any) : React.ReactNode {
        const outline = this.on ? "#f04979" : "#dba9ff"; 
        return <div key={this.id} className="width-64 height-64 v-box center-all" style={{
            border: '4px solid ' + outline,
            borderRadius: '4px',
            background: '#e4beff'
        }}>
            <img src={this.src} className="width-100p height-100p cursor-pointer" style={{
                objectFit: 'contain'
            }} onClick={() => {
                this.on = !this.on;
                onClick();
            }} /> 
        </div>
    }

    render() : React.ReactNode {
        if (!this.on)
            return null;
        return <img src={this.src} key={this.id} className="pos-abs" style={{height: this.height+"%", left: this.x+"%", top: this.y+"%"}} />
    }
}

class DRESSUP_CONFIG {
    options: DRESSUP_OPTION[] = [];
}

const TIE_OPTION = new DRESSUP_OPTION (1, clothes_tie, 47.64, 11.6, 33);
const BOWTIE_OPTION = new DRESSUP_OPTION(2, clothes_bowtie, 14.88, 11.6, 35);
const BLACK_OPTION = new DRESSUP_OPTION(3, makeup_black, 21.14, 14.6, 6.5);
const BLUSH_OPTION = new DRESSUP_OPTION(4, makeup_blush, 12, 12, 16.5);
const MOONS_OPTION = new DRESSUP_OPTION(5, makeup_moons, 13.09, 16.4, 8.5);
const TRIANGLES_OPTION = new DRESSUP_OPTION(6, makeup_triangles, 25.42, 14.4, 4.5);
const TEARS_OPTION = new DRESSUP_OPTION(7, makeup_tears, 18.33, 14.4, 14.5);
const OUTLINE_OPTION = new DRESSUP_OPTION(8, makeup_outline, 12.9, 14.4, 22);
const LIPS_OPTION = new DRESSUP_OPTION(9, makeup_lips, 13.22, 14, 22.5);
const SPOT1_OPTION = new DRESSUP_OPTION(10, makeup_spot1, 13.92, 53, 30);
const SPOT2_OPTION = new DRESSUP_OPTION(11, makeup_spot2, 4.09, 52.5, 70);
const SPOT3_OPTION = new DRESSUP_OPTION(12, makeup_spot3, 17.82, 34, 65);
const SPOT4_OPTION = new DRESSUP_OPTION(13, makeup_spot4, 19.16, 72, 45);
const SPOT5_OPTION = new DRESSUP_OPTION(14, makeup_spot5, 14.81, 67, 30);
const BLUEEARS_OPTION = new DRESSUP_OPTION(15, ear_blue, 43.49, 33.8, 7.8);
const PINKEARS_OPTION = new DRESSUP_OPTION(16, ear_pink, 40.68, 2, 0);
const NOSE_OPTION = new DRESSUP_OPTION(17, clothes_nose, 9.58, 21, 13);
const SHOESF_OPTION = new DRESSUP_OPTION(18, clothes_shoes, 28.16, -3, 75);
const SHOESB_OPTION = new DRESSUP_OPTION(19, clothes_shoes, 28.16, 50, 75);
const FLOWER_OPTION = new DRESSUP_OPTION(20, clothes_flower, 54.66, -1.7, 3.2);
const WIG_OPTION = new DRESSUP_OPTION(21, wig, 39.78, 6.5, -21);

const config : DRESSUP_CONFIG = {
    options: [
        TIE_OPTION,
        BOWTIE_OPTION,
        BLACK_OPTION,
        BLUSH_OPTION,
        MOONS_OPTION,
        TRIANGLES_OPTION,
        TEARS_OPTION,
        OUTLINE_OPTION,
        LIPS_OPTION,
        SPOT1_OPTION,
        SPOT2_OPTION,
        SPOT3_OPTION,
        SPOT4_OPTION,
        SPOT5_OPTION,
        BLUEEARS_OPTION,
        PINKEARS_OPTION,
        NOSE_OPTION,
        SHOESF_OPTION,
        SHOESB_OPTION,
        FLOWER_OPTION,
        WIG_OPTION
    ]
}

export function DRESSUP(props: { onClick: () => void }) {
    const [clicks, setClicks] = useState(0);
    const state : string|null = localStorage.getItem('BDUDATA');
    const data = useRef<number[]>(state == null ? [] : JSON.parse(state));
    const loaded = useRef<boolean>(false);
    if (!loaded.current)
    {
        config.options.forEach(o => { o.load(data.current); });
        loaded.current = true;
    }
    

    useEffect(() => {
        let d : number[] = [];
        config.options.forEach((o) => {
            if (o.on)
                d.push(o.id);
        });
        localStorage.setItem('BDUDATA', JSON.stringify(d));
        data.current = d;
    }, [clicks]);

    return <div className='v-box padding-32 pos-rel yes-events' style={{ width: 1024, height: 512 }}>
        <DRESSUPBG />
        <div className="h-box gap-64 align-end" style={{height: 480}}>
            <div className="v-box justify-start height-100p">
                <FunTitle title="Bongo Dressup!" />
                <div className="h-box" style={{padding: '0 16px'}}>
                    <p className="text-taco-black font-taco-secondary z-3">Our beloved friend Bongo needs help getting dressed for the big show at Taco Bongo! What should Bongo wear??</p>
                </div>
                <DRESSUPSELECTOR onClick={() => { 
                    setClicks(clicks + 1);
                    props.onClick();
                }} />
            </div>
            <div className="v-box pos-rel" style={{height: 384}}>
                <img src={spotlight} className="pos-abs" style={{ left: -64, top: -128, width: 512}} />
                {/* <div className="pos-rel width-384"></div> */}
                <BONGODRESSED />
            </div>
        </div>
    </div>
}

function DRESSUPBG () {
    const tacoProvider = useContext(TACOProvider.context);
    return <CursorComponent cursor={CursorState.HAM} onClick={() => {
        tacoProvider.exitGame(true);
    }}>
        <div className="pos-abs taco-box" style={{
            top:-32, left:-32, right:-32, bottom:-32
        }}>
        </div>
    </CursorComponent>
}

export function FunTitle(props: {title: string}) {
    var array = props.title.split('');
    return <span className="h-box">
        {
            array.map((c, i) => {
                let color : string = '';
                const ip = i % 3;
                switch (ip)
                {
                    case 0:
                        color = 'text-taco-teal';
                        break;
                    case 1:
                        color = 'text-taco-pink';
                        break;
                    case 2:
                        color = 'text-taco-purp';
                        break;
                }

                const className = color + " font-taco-primary text-48 floaty-1s";
                const style = { animationDelay : (-i * 0.1) + "s" };
                if (c === ' ')
                    return <span key={i} className={ className } style={style}>&nbsp;</span>
                return <span key={i} className={ className } style={style}><b>{ c }</b></span>
            })
        }
    </span>
}

function DRESSUPSELECTOR(props: { onClick: any }) {
    return <div className="grid gap-16 z-1" style={{gridTemplateColumns: "64px 64px 64px 64px 64px 64px 64px"}}>
        { config.options.map (o => o.icon(props.onClick)) }
    </div>
}

export function BONGODRESSED() {
    const options = config.options.map (o => o.render());

    return <div className="pos-rel height-100p ">
        <img src={bongo_base} className="height-100p" />
        { options }
    </div>
}

export function BONGO (props: {height: number}) {
    const state : string|null = localStorage.getItem('BDUDATA');
    const data = useRef<number[]>(state == null ? [] : JSON.parse(state));
    config.options.forEach(o => { o.load(data.current); });
    const ratio = 412.0 / 384.0;
    return <div className="v-box pos-rel" style={{width: props.height * ratio, height: props.height}}>
        {/* <img src={spotlight} className="pos-abs" style={{ left: -64, top: -128, width: 512}} /> */}
        <BONGODRESSED />
    </div>
}